import React from "react";

function SocialShareIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
    >
      <path
        fill="#000"
        d="M13.5 10h-1a.5.5 0 00-.5.5V14H2V4h4.5a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-5A1.5 1.5 0 000 3.5v11A1.5 1.5 0 001.5 16h11a1.5 1.5 0 001.5-1.5v-4a.5.5 0 00-.5-.5zm1.75-10h-4c-.668 0-1.002.81-.531 1.281l1.116 1.117-7.616 7.614a.749.749 0 000 1.062l.708.707a.75.75 0 001.063 0l7.612-7.615 1.117 1.115c.469.469 1.281.14 1.281-.531v-4a.75.75 0 00-.75-.75z"
      ></path>
    </svg>
  );
}

export default SocialShareIcon;
